import Image from 'next/image'
import { memo } from 'react'
// Components
import Button from '@/components/newButton/Button'

import styles from './PuppyQuizBanner.module.scss'

const PuppyQuizBanner = () => {
  return (
    <div className={styles.quizBanner}>
      <div className={styles.banner}>
        <div className={styles.content}>
          <div className={styles.dogDesk}>
            <Image
              src="/search/wizard-desk.svg"
              width={279}
              height={275}
              alt="Great Dane dog with a red wizard hat"
              loading="lazy"
              style={{ width: '100%', height: 'auto' }}
            />
          </div>
          <div className={styles.dogMob}>
            <Image
              src="/search/wizard-mobile.png"
              width={300}
              height={250}
              alt="Great Dane dog with a red wizard hat"
              loading="lazy"
              style={{ width: '100%', height: 'auto' }}
            />
          </div>

          <div className={styles.text}>
            <h2>Let our Wizard help you! 🪄</h2>
            <p>
              Find your perfect puppy with our interactive Puppy Match Quiz!
            </p>
          </div>
        </div>

        <Button
          title="Try Puppy Match Quiz"
          theme={['pink-solid', 'medium']}
          hRef="/dog-breed-quiz"
          className={styles.btn}
        />
      </div>
    </div>
  )
}

export default memo(PuppyQuizBanner)
